var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExit = function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.001 17.333a8.333 8.333 0 1 1 6.667-13.334H13.41a6.667 6.667 0 1 0 0 10h2.259A8.32 8.32 0 0 1 9 17.333m5.834-5v-2.5H8.168V8.166h6.667v-2.5L19 8.999z"
  })));
};
export default SvgExit;